import {
  FETCH_ASSEMBLY_DATA,
  SET_ASSEMBLY_DATA,
  SET_ASSEMBLY_DATA_FAILURE,
  CLEAR_ASSEMBLY_DATA,
  FETCH_ASSEMBLY_DETAILS,
  SET_ASSEMBLY_DETAILS,
  SET_ASSEMBLY_DETAILS_FAILURE,
  CLEAR_ASSEMBLY_DETAILS,
  UPLOAD_NDT_DOCUMENT,
  SET_NDT_UPLOAD_SUCCESS,
  SET_NDT_UPLOAD_FAILURE,
  UPDATE_ASSEMBLY_STATUS,
  SET_ASSEMBLY_STATUS_SUCCESS,
  SET_ASSEMBLY_STATUS_FAILURE,
  FETCH_ASSEMBLY_FILTERS,
  SET_ASSEMBLY_FILTERS,
  SET_ASSEMBLY_FILTERS_FAILURE,
  UPDATE_ASSEMBLY_FITMENT,
  SET_ASSEMBLY_FITMENT_SUCCESS,
  SET_ASSEMBLY_FITMENT_FAILURE,
  FETCH_GPS_DATA,
  SET_GPS_DATA,
  SET_GPS_DATA_FAILURE,
  CLEAR_GPS_DATA,
  UPDATE_ASSEMBLY_VISUAL_INSPECTION,
  SET_ASSEMBLY_VISUAL_INSPECTION_SUCCESS,
  SET_ASSEMBLY_VISUAL_INSPECTION_FAILURE,
  UPDATE_ASSEMBLY_ALIGNMENT,
  SET_ASSEMBLY_ALIGNMENT_SUCCESS,
  SET_ASSEMBLY_ALIGNMENT_FAILURE,
  FETCH_PRODUCTION_DATA,
  SET_PRODUCTION_DATA,
  SET_PRODUCTION_DATA_FAILURE,
  CLEAR_PRODUCTION_DATA,
  GET_ALL_TEAM_MEMBERS,
  SET_TEAM_MEMBERS,
  SET_TEAM_MEMBERS_FAILURE,
  CLEAR_TEAM_MEMBERS,
  FETCH_LIMITS_DATA,
  SET_LIMITS_DATA,
  SET_LIMITS_DATA_FAILURE,
  CLEAR_LIMITS_DATA,
  UPDATE_STATUS_CONFIGURATION,
  SET_STATUS_CONFIGURATION_SUCCESS,
  SET_STATUS_CONFIGURATION_FAILURE,
  FETCH_WELD_PARAMETERS,
  SET_WELD_PARAMETERS,
  SET_WELD_PARAMETERS_FAILURE,
  CLEAR_WELD_PARAMETERS,
  SET_WELD_PARAMETERS_MODAL_OPEN,
  DOWNLOAD_FITMENT_REPORT,
  SET_FITMENT_REPORT_DOWNLOAD_SUCCESS,
  SET_FITMENT_REPORT_DOWNLOAD_FAILURE,
  CLEAR_FITMENT_REPORT_DOWNLOAD,
  DOWNLOAD_VISUAL_INSPECTION_REPORT,
  SET_VISUAL_INSPECTION_REPORT_DOWNLOAD_SUCCESS,
  SET_VISUAL_INSPECTION_REPORT_DOWNLOAD_FAILURE,
  CLEAR_VISUAL_INSPECTION_REPORT_DOWNLOAD,
  DOWNLOAD_ALIGNMENT_REPORT,
  SET_ALIGNMENT_REPORT_DOWNLOAD_SUCCESS,
  SET_ALIGNMENT_REPORT_DOWNLOAD_FAILURE,
  CLEAR_ALIGNMENT_REPORT_DOWNLOAD,
  DOWNLOAD_PRODUCTION_SHEET_MERGED_REPORT,
  SET_PRODUCTION_SHEET_MERGED_REPORT_DOWNLOAD_SUCCESS,
  SET_PRODUCTION_SHEET_MERGED_REPORT_DOWNLOAD_FAILURE,
  CLEAR_PRODUCTION_SHEET_MERGED_REPORT_DOWNLOAD,
  DOWNLOAD_PRODUCTION_SHEET_MAIN_REPORT,
  SET_PRODUCTION_SHEET_MAIN_REPORT_DOWNLOAD_SUCCESS,
  SET_PRODUCTION_SHEET_MAIN_REPORT_DOWNLOAD_FAILURE,
  CLEAR_PRODUCTION_SHEET_MAIN_REPORT_DOWNLOAD,
  FETCH_NDT_INDICATION_LOGS,
  SET_NDT_INDICATION_LOGS,
  SET_NDT_INDICATION_LOGS_FAILURE,
  CLEAR_NDT_INDICATION_LOGS,
  CREATE_NDT_REPAIR_LOG,
  SET_CREATE_NDT_REPAIR_LOG_SUCCESS,
  SET_CREATE_NDT_REPAIR_LOG_FAILURE,
  UPDATE_NDT_REPAIR_LOG,
  SET_UPDATE_NDT_REPAIR_LOG_SUCCESS,
  SET_UPDATE_NDT_REPAIR_LOG_FAILURE,
  DELETE_NDT_REPAIR_LOG,
  SET_DELETE_NDT_REPAIR_LOG_SUCCESS,
  SET_DELETE_NDT_REPAIR_LOG_FAILURE,
  FETCH_NDT_REPAIR_LOG_DOC,
  SET_NDT_REPAIR_LOG_DOC,
  SET_NDT_REPAIR_LOG_DOC_FAILURE,
  UPLOAD_NDT_REPAIR_LOG_DOC,
  SET_NDT_REPAIR_LOG_DOC_SUCCESS,
  CLEAR_NDT_REPAIR_LOG_DOC,
  FETCH_NDT_CATEGORIES,
  SET_NDT_CATEGORIES,
  SET_NDT_CATEGORIES_FAILURE,
  GENERATE_PROJECT_PRODUCTION_SHEET_REPORT,
  SET_PROJECT_PRODUCTION_SHEET_REPORT_SUCCESS,
  SET_PROJECT_PRODUCTION_SHEET_REPORT_FAILURE,
  CLEAR_PROJECT_PRODUCTION_SHEET_REPORT,
  GENERATE_REPORT_ASSEMBLY,
  SET_GENERATE_REPORT_ASSEMBLY_SUCCESS,
  SET_GENERATE_REPORT_ASSEMBLY_FAILURE,
  CLEAR_GENERATE_REPORT_ASSEMBLY,
  GENERATE_IRN_REPORT,
  SET_IRN_REPORT_SUCCESS,
  SET_IRN_REPORT_FAILURE,
  CLEAR_IRN_REPORT,
  GET_IRN_REPORT_VERSIONS,
  GET_IRN_REPORT_VERSIONS_SUCCESS,
  GET_IRN_REPORT_VERSIONS_FAILURE,
  GET_PRODUCTION_REPORT_VERSIONS,
  GET_PRODUCTION_REPORT_VERSIONS_SUCCESS,
  GET_PRODUCTION_REPORT_VERSIONS_FAILURE,
  DELETE_REPAIR_WELD,
  SET_DELETE_REPAIR_WELD_SUCCESS,
  SET_DELETE_REPAIR_WELD_FAILURE,
  CLEAR_DELETE_REPAIR_WELD,
  PRODUCTION_SHEET_SAVE_SIGNATURE,
  SET_PRODUCTION_SHEET_SAVE_SIGNATURE_SUCCESS,
  SET_PRODUCTION_SHEET_SAVE_SIGNATURE_FAILURE,
  CLEAR_PRODUCTION_SHEET_SAVE_SIGNATURE,
  FETCH_ARK_REGISTRY_DOCS,
  SET_ARK_REGISTRY_DOCS,
  SET_ARK_REGISTRY_DOCS_FAILURE,
  UPLOAD_ARK_REGISTRY_DOC,
  SET_ARK_REGISTRY_DOC_SUCCESS,
  DELETE_ARK_REGISTRY_DOC,
  SET_DELETE_ARK_REGISTRY_DOC_SUCCESS,
  SET_DELETE_ARK_REGISTRY_DOC_FAILURE,
  CLEAR_ARK_REGISTRY_DOCS,
  GET_ARK_REGISTRY_DOWNLOAD_URL,
  SET_ARK_REGISTRY_DOWNLOAD_URL,
  GET_ARK_REGISTRY_PRESIGNED_URL,
  SET_ARK_REGISTRY_PRESIGNED_URL,
  GENERATE_PROJECT_REPORT,
  GENERATE_PROJECT_REPORT_SUCCESS,
  GENERATE_PROJECT_REPORT_FAILURE,
  CLEAR_GENERATE_PROJECT_REPORT,
  GET_PROJECT_REPORT_VERSIONS,
  GET_PROJECT_REPORT_VERSIONS_SUCCESS,
  GET_PROJECT_REPORT_VERSIONS_FAILURE
} from './types';

// Action creators for Assembly Data
export const fetchAssemblyData = (payload) => ({
  type: FETCH_ASSEMBLY_DATA,
  payload
});

export const setAssemblyData = (payload) => {
  if (Array.isArray(payload)) {
    return {
      type: SET_ASSEMBLY_DATA,
      assemblyData: payload,
      assemblyTotalCount: payload.length
    };
  }
  return {
    type: SET_ASSEMBLY_DATA,
    assemblyData: payload.assemblyData,
    assemblyTotalCount: payload.assemblyTotalCount ?? payload.assemblyData?.length ?? 0
  };
};

export const setAssemblyDataFailure = (error) => ({
  type: SET_ASSEMBLY_DATA_FAILURE,
  error
});

export const clearAssemblyData = () => ({
  type: CLEAR_ASSEMBLY_DATA
});

// Action creators for Assembly Details
export const fetchAssemblyDetails = (payload) => ({
  type: FETCH_ASSEMBLY_DETAILS,
  payload
});

export const setAssemblyDetails = (assemblyDetails) => ({
  type: SET_ASSEMBLY_DETAILS,
  assemblyDetails
});

export const setAssemblyDetailsFailure = (error) => ({
  type: SET_ASSEMBLY_DETAILS_FAILURE,
  error
});

export const clearAssemblyDetails = () => ({
  type: CLEAR_ASSEMBLY_DETAILS
});

// Action creators for NDT Document Upload
export const uploadNDTDocument = (payload) => ({
  type: UPLOAD_NDT_DOCUMENT,
  payload
});

export const setNDTUploadSuccess = (assemblyNumber, documentData) => ({
  type: SET_NDT_UPLOAD_SUCCESS,
  assemblyNumber,
  documentData
});

export const setNDTUploadFailure = (error) => ({
  type: SET_NDT_UPLOAD_FAILURE,
  error
});

// Action creators for Assembly Status Update
export const updateAssemblyStatus = (payload) => ({
  type: UPDATE_ASSEMBLY_STATUS,
  payload
});

export const setAssemblyStatusSuccess = (assemblyNumber, status) => ({
  type: SET_ASSEMBLY_STATUS_SUCCESS,
  assemblyNumber,
  status
});

export const setAssemblyStatusFailure = (error) => ({
  type: SET_ASSEMBLY_STATUS_FAILURE,
  error
});

// Action creators for Assembly Filters
export const fetchAssemblyFilters = (payload) => ({
  type: FETCH_ASSEMBLY_FILTERS,
  payload
});

export const setAssemblyFilters = (filters) => ({
  type: SET_ASSEMBLY_FILTERS,
  filters
});

export const setAssemblyFiltersFailure = (error) => ({
  type: SET_ASSEMBLY_FILTERS_FAILURE,
  error
});

// Action creators for Assembly Fitment Data
export const updateAssemblyFitment = (payload) => ({
  type: UPDATE_ASSEMBLY_FITMENT,
  payload
});

export const setAssemblyFitmentSuccess = (assemblyNumber, fitmentData) => ({
  type: SET_ASSEMBLY_FITMENT_SUCCESS,
  assemblyNumber,
  fitmentData
});

export const setAssemblyFitmentFailure = (error) => ({
  type: SET_ASSEMBLY_FITMENT_FAILURE,
  error
});

// Action creators for GPS Data
export const fetchGpsData = (payload) => ({
  type: FETCH_GPS_DATA,
  payload
});

export const setGpsData = (gpsData) => ({
  type: SET_GPS_DATA,
  gpsData
});

export const setGpsDataFailure = (error) => ({
  type: SET_GPS_DATA_FAILURE,
  error
});

export const clearGpsData = () => ({
  type: CLEAR_GPS_DATA
});

// Additional action creators for missing functions
export const updateAssemblyVisualInspection = (payload) => ({
  type: UPDATE_ASSEMBLY_VISUAL_INSPECTION,
  payload
});

export const updateAssemblyAlignment = (payload) => ({
  type: UPDATE_ASSEMBLY_ALIGNMENT,
  payload
});

// Action creators for Assembly Visual Inspection Update
export const setAssemblyVisualInspectionSuccess = (assemblyNumber, visualInspectionData) => ({
  type: SET_ASSEMBLY_VISUAL_INSPECTION_SUCCESS,
  assemblyNumber,
  visualInspectionData
});

export const setAssemblyVisualInspectionFailure = (error) => ({
  type: SET_ASSEMBLY_VISUAL_INSPECTION_FAILURE,
  error
});

// Action creators for Assembly Alignment Update
export const setAssemblyAlignmentSuccess = (assemblyNumber, alignmentData) => ({
  type: SET_ASSEMBLY_ALIGNMENT_SUCCESS,
  assemblyNumber,
  alignmentData
});

export const setAssemblyAlignmentFailure = (error) => ({
  type: SET_ASSEMBLY_ALIGNMENT_FAILURE,
  error
});

// Action creators for Production Data
export const fetchProductionData = (payload) => ({
  type: FETCH_PRODUCTION_DATA,
  payload
});


// Action creators for Production Data
export const setProductionData = (productionData) => ({
  type: SET_PRODUCTION_DATA,
  productionData
});

export const setProductionDataFailure = (error) => ({
  type: SET_PRODUCTION_DATA_FAILURE,
  error
});

export const clearProductionData = () => ({
  type: CLEAR_PRODUCTION_DATA
});

// Action creators for Team Members
export const getAllTeamMembers = (projectId) => ({
  type: GET_ALL_TEAM_MEMBERS,
  payload: { projectId }
});

export const setTeamMembers = (teamMembers) => ({
  type: SET_TEAM_MEMBERS,
  payload: teamMembers
});

export const setTeamMembersFailure = (error) => ({
  type: SET_TEAM_MEMBERS_FAILURE,
  error
});

export const clearTeamMembers = () => ({
  type: CLEAR_TEAM_MEMBERS
});

// Action creators for Limits Data
export const fetchLimitsData = (projectId) => ({
  type: FETCH_LIMITS_DATA,
  payload: { projectId }
});

export const setLimitsData = (limitsData) => ({
  type: SET_LIMITS_DATA,
  payload: limitsData
});

export const setLimitsDataFailure = (error) => ({
  type: SET_LIMITS_DATA_FAILURE,
  error
});

export const clearLimitsData = () => ({
  type: CLEAR_LIMITS_DATA
});

// Action creators for Status Configuration
export const updateStatusConfiguration = (payload) => ({
  type: UPDATE_STATUS_CONFIGURATION,
  payload
});

export const setStatusConfigurationSuccess = (data) => ({
  type: SET_STATUS_CONFIGURATION_SUCCESS,
  payload: data
});

export const setStatusConfigurationFailure = (error) => ({
  type: SET_STATUS_CONFIGURATION_FAILURE,
  error
});

// Action creators for Weld Parameters
export const fetchWeldParameters = (projectId) => ({
  type: FETCH_WELD_PARAMETERS,
  payload: { projectId }
});

export const setWeldParameters = (weldParameters) => ({
  type: SET_WELD_PARAMETERS,
  payload: weldParameters
});

export const setWeldParametersFailure = (error) => ({
  type: SET_WELD_PARAMETERS_FAILURE,
  error
});

export const clearWeldParameters = () => ({
  type: CLEAR_WELD_PARAMETERS
});

export const setWeldParametersModalOpen = (isOpen, machineType = null) => ({
  type: SET_WELD_PARAMETERS_MODAL_OPEN,
  payload: { isOpen, machineType }
});

// Action creators for Fitment Report Download
export const downloadFitmentReport = (payload) => ({
  type: DOWNLOAD_FITMENT_REPORT,
  payload
});

export const setFitmentReportDownloadSuccess = (downloadData) => ({
  type: SET_FITMENT_REPORT_DOWNLOAD_SUCCESS,
  payload: downloadData
});

export const setFitmentReportDownloadFailure = (error) => ({
  type: SET_FITMENT_REPORT_DOWNLOAD_FAILURE,
  error
});

export const clearFitmentReportDownload = () => ({
  type: CLEAR_FITMENT_REPORT_DOWNLOAD
});

// Action creators for Visual Inspection Report Download
export const downloadVisualInspectionReport = (payload) => ({
  type: DOWNLOAD_VISUAL_INSPECTION_REPORT,
  payload
});

export const setVisualInspectionReportDownloadSuccess = (downloadData) => ({
  type: SET_VISUAL_INSPECTION_REPORT_DOWNLOAD_SUCCESS,
  payload: downloadData
});

export const setVisualInspectionReportDownloadFailure = (error) => ({
  type: SET_VISUAL_INSPECTION_REPORT_DOWNLOAD_FAILURE,
  error
});

export const clearVisualInspectionReportDownload = () => ({
  type: CLEAR_VISUAL_INSPECTION_REPORT_DOWNLOAD
});

// Action creators for Alignment Report Download
export const downloadAlignmentReport = (payload) => ({
  type: DOWNLOAD_ALIGNMENT_REPORT,
  payload
});

export const setAlignmentReportDownloadSuccess = (downloadData) => ({
  type: SET_ALIGNMENT_REPORT_DOWNLOAD_SUCCESS,
  payload: downloadData
});

export const setAlignmentReportDownloadFailure = (error) => ({
  type: SET_ALIGNMENT_REPORT_DOWNLOAD_FAILURE,
  error
});

export const clearAlignmentReportDownload = () => ({
  type: CLEAR_ALIGNMENT_REPORT_DOWNLOAD
});

// Action creators for Production Sheet Merged Report Download
export const downloadProductionSheetMergedReport = (payload) => ({
  type: DOWNLOAD_PRODUCTION_SHEET_MERGED_REPORT,
  payload
});

export const setProductionSheetMergedReportDownloadSuccess = (downloadData) => ({
  type: SET_PRODUCTION_SHEET_MERGED_REPORT_DOWNLOAD_SUCCESS,
  payload: downloadData
});

export const setProductionSheetMergedReportDownloadFailure = (error) => ({
  type: SET_PRODUCTION_SHEET_MERGED_REPORT_DOWNLOAD_FAILURE,
  error
});

export const clearProductionSheetMergedReportDownload = () => ({
  type: CLEAR_PRODUCTION_SHEET_MERGED_REPORT_DOWNLOAD
});

// Action creators for Production Sheet Main Report Download
export const downloadProductionSheetMainReport = (payload) => ({
  type: DOWNLOAD_PRODUCTION_SHEET_MAIN_REPORT,
  payload
});

export const setProductionSheetMainReportDownloadSuccess = (downloadData) => ({
  type: SET_PRODUCTION_SHEET_MAIN_REPORT_DOWNLOAD_SUCCESS,
  payload: downloadData
});

export const setProductionSheetMainReportDownloadFailure = (error) => ({
  type: SET_PRODUCTION_SHEET_MAIN_REPORT_DOWNLOAD_FAILURE,
  error
});

export const clearProductionSheetMainReportDownload = () => ({
  type: CLEAR_PRODUCTION_SHEET_MAIN_REPORT_DOWNLOAD
});

// Action creators for NDT Indication Log
export const fetchNDTIndicationLogs = (payload) => ({
  type: FETCH_NDT_INDICATION_LOGS,
  payload
});

export const setNDTIndicationLogs = (logs) => ({
  type: SET_NDT_INDICATION_LOGS,
  payload: logs
});

export const setNDTIndicationLogsFailure = (error) => ({
  type: SET_NDT_INDICATION_LOGS_FAILURE,
  error
});

export const clearNDTIndicationLogs = () => ({
  type: CLEAR_NDT_INDICATION_LOGS
});

// Action creators for Create NDT Repair Log
export const createNDTRepairLog = (payload) => ({
  type: CREATE_NDT_REPAIR_LOG,
  payload
});

export const setCreateNDTRepairLogSuccess = (log) => ({
  type: SET_CREATE_NDT_REPAIR_LOG_SUCCESS,
  payload: log
});

export const setCreateNDTRepairLogFailure = (error) => ({
  type: SET_CREATE_NDT_REPAIR_LOG_FAILURE,
  error
});

// Action creators for Update NDT Repair Log
export const updateNDTRepairLog = (payload) => ({
  type: UPDATE_NDT_REPAIR_LOG,
  payload
});

export const setUpdateNDTRepairLogSuccess = (log) => ({
  type: SET_UPDATE_NDT_REPAIR_LOG_SUCCESS,
  payload: log
});

export const setUpdateNDTRepairLogFailure = (error) => ({
  type: SET_UPDATE_NDT_REPAIR_LOG_FAILURE,
  error
});

// Action creators for Delete NDT Repair Log
export const deleteNDTRepairLog = (payload) => ({
  type: DELETE_NDT_REPAIR_LOG,
  payload
});

export const setDeleteNDTRepairLogSuccess = () => ({
  type: SET_DELETE_NDT_REPAIR_LOG_SUCCESS
});

export const setDeleteNDTRepairLogFailure = (error) => ({
  type: SET_DELETE_NDT_REPAIR_LOG_FAILURE,
  error
});

// Action creators for NDT Repair Log Documents
export const fetchNDTRepairLogDoc = (payload) => ({
  type: FETCH_NDT_REPAIR_LOG_DOC,
  payload
});

export const setNDTRepairLogDoc = (docs) => ({
  type: SET_NDT_REPAIR_LOG_DOC,
  payload: docs
});

export const setNDTRepairLogDocFailure = (error) => ({
  type: SET_NDT_REPAIR_LOG_DOC_FAILURE,
  error
});

export const uploadNDTRepairLogDoc = (payload) => ({
  type: UPLOAD_NDT_REPAIR_LOG_DOC,
  payload
});

export const setNDTRepairLogDocSuccess = (docs) => ({
  type: SET_NDT_REPAIR_LOG_DOC_SUCCESS,
  payload: docs
});

export const clearNDTRepairLogDoc = () => ({
  type: CLEAR_NDT_REPAIR_LOG_DOC,
  payload: null
});

// Action creators for NDT Indication Log Categories (filter dropdowns)
export const fetchNDTCategories = (payload) => ({
  type: FETCH_NDT_CATEGORIES,
  payload
});

export const setNDTCategories = (payload) => ({
  type: SET_NDT_CATEGORIES,
  payload
});

export const setNDTCategoriesFailure = (error) => ({
  type: SET_NDT_CATEGORIES_FAILURE,
  error
});

// Action creators for Project Production Sheet Report Generation
export const generateProjectProductionSheetReport = (payload) => ({
  type: GENERATE_PROJECT_PRODUCTION_SHEET_REPORT,
  payload
});

export const setProjectProductionSheetReportSuccess = (reportData) => ({
  type: SET_PROJECT_PRODUCTION_SHEET_REPORT_SUCCESS,
  payload: reportData
});

export const setProjectProductionSheetReportFailure = (error) => ({
  type: SET_PROJECT_PRODUCTION_SHEET_REPORT_FAILURE,
  error
});

export const clearProjectProductionSheetReport = () => ({
  type: CLEAR_PROJECT_PRODUCTION_SHEET_REPORT
});

// Action creators for Generate Weld Report for Assembly
export const generateReportAssembly = (payload) => ({
  type: GENERATE_REPORT_ASSEMBLY,
  payload
});

export const setGenerateReportAssemblySuccess = (reportData) => ({
  type: SET_GENERATE_REPORT_ASSEMBLY_SUCCESS,
  payload: reportData
});

export const setGenerateReportAssemblyFailure = (error) => ({
  type: SET_GENERATE_REPORT_ASSEMBLY_FAILURE,
  error
});

export const clearGenerateReportAssembly = () => ({
  type: CLEAR_GENERATE_REPORT_ASSEMBLY
});

// Action creators for IRN Report Generation
export const generateIRNReport = (payload) => ({
  type: GENERATE_IRN_REPORT,
  payload
});

export const setIRNReportSuccess = (reportData) => ({
  type: SET_IRN_REPORT_SUCCESS,
  payload: reportData
});

export const setIRNReportFailure = (error) => ({
  type: SET_IRN_REPORT_FAILURE,
  error
});

export const clearIRNReport = () => ({
  type: CLEAR_IRN_REPORT
});

// Action creators for IRN Report Versions
export const getIRNReportVersions = (projectId) => ({
  type: GET_IRN_REPORT_VERSIONS,
  projectId
});

export const getIRNReportVersionsSuccess = (payload) => ({
  type: GET_IRN_REPORT_VERSIONS_SUCCESS,
  payload
});

export const getIRNReportVersionsFailure = (error) => ({
  type: GET_IRN_REPORT_VERSIONS_FAILURE,
  error
});

// Action creators for Production Report Versions
export const getProductionReportVersions = (projectId) => ({
  type: GET_PRODUCTION_REPORT_VERSIONS,
  projectId
});

export const getProductionReportVersionsSuccess = (payload) => ({
  type: GET_PRODUCTION_REPORT_VERSIONS_SUCCESS,
  payload
});

export const getProductionReportVersionsFailure = (error) => ({
  type: GET_PRODUCTION_REPORT_VERSIONS_FAILURE,
  error
});

// Action creators for Delete Repair Weld
export const deleteRepairWeld = (payload) => ({
  type: DELETE_REPAIR_WELD,
  payload
});

export const setDeleteRepairWeldSuccess = (data) => ({
  type: SET_DELETE_REPAIR_WELD_SUCCESS,
  payload: data
});

export const setDeleteRepairWeldFailure = (error) => ({
  type: SET_DELETE_REPAIR_WELD_FAILURE,
  error
});

export const clearDeleteRepairWeld = () => ({
  type: CLEAR_DELETE_REPAIR_WELD
});

// Action creators for Production Sheet Save Signature
export const productionSheetSaveSignature = (payload) => ({
  type: PRODUCTION_SHEET_SAVE_SIGNATURE,
  payload
});

export const setProductionSheetSaveSignatureSuccess = (data) => ({
  type: SET_PRODUCTION_SHEET_SAVE_SIGNATURE_SUCCESS,
  payload: data
});

export const setProductionSheetSaveSignatureFailure = (error) => ({
  type: SET_PRODUCTION_SHEET_SAVE_SIGNATURE_FAILURE,
  error
});

export const clearProductionSheetSaveSignature = () => ({
  type: CLEAR_PRODUCTION_SHEET_SAVE_SIGNATURE
});

// Action creators for ARK Registry Documents
export const fetchARKRegistryDocs = (payload) => ({
  type: FETCH_ARK_REGISTRY_DOCS,
  payload
});

export const setARKRegistryDocs = (docs) => ({
  type: SET_ARK_REGISTRY_DOCS,
  payload: docs
});

export const setARKRegistryDocsFailure = (error) => ({
  type: SET_ARK_REGISTRY_DOCS_FAILURE,
  error
});

export const uploadARKRegistryDoc = (payload) => ({
  type: UPLOAD_ARK_REGISTRY_DOC,
  payload
});

export const setARKRegistryDocSuccess = (docs) => ({
  type: SET_ARK_REGISTRY_DOC_SUCCESS,
  payload: docs
});

export const deleteARKRegistryDoc = (payload) => ({
  type: DELETE_ARK_REGISTRY_DOC,
  payload
});

export const setDeleteARKRegistryDocSuccess = () => ({
  type: SET_DELETE_ARK_REGISTRY_DOC_SUCCESS
});

export const setDeleteARKRegistryDocFailure = (error) => ({
  type: SET_DELETE_ARK_REGISTRY_DOC_FAILURE,
  error
});

export const clearARKRegistryDocs = () => ({
  type: CLEAR_ARK_REGISTRY_DOCS
});

export const getARKRegistryDownloadUrl = (payload) => ({
  type: GET_ARK_REGISTRY_DOWNLOAD_URL,
  payload
});

export const setARKRegistryDownloadUrl = (data) => ({
  type: SET_ARK_REGISTRY_DOWNLOAD_URL,
  payload: data
});

export const getARKRegistryPresignedUrl = (payload) => ({
  type: GET_ARK_REGISTRY_PRESIGNED_URL,
  payload
});

export const setARKRegistryPresignedUrl = (data) => ({
  type: SET_ARK_REGISTRY_PRESIGNED_URL,
  payload: data
});

// Action creators for Generate Project Report
export const generateProjectReport = (payload) => ({
  type: GENERATE_PROJECT_REPORT,
  payload
});

export const generateProjectReportSuccess = (data) => ({
  type: GENERATE_PROJECT_REPORT_SUCCESS,
  payload: data
});

export const generateProjectReportFailure = (error) => ({
  type: GENERATE_PROJECT_REPORT_FAILURE,
  error
});

export const clearGenerateProjectReport = () => ({
  type: CLEAR_GENERATE_PROJECT_REPORT
});

// Action creators for Get Project Report Versions
export const getProjectReportVersions = (projectId) => ({
  type: GET_PROJECT_REPORT_VERSIONS,
  projectId
});

export const getProjectReportVersionsSuccess = (payload) => ({
  type: GET_PROJECT_REPORT_VERSIONS_SUCCESS,
  payload
});

export const getProjectReportVersionsFailure = (error) => ({
  type: GET_PROJECT_REPORT_VERSIONS_FAILURE,
  error
}); 